import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["icon"];
import * as React from 'react';
import * as styles from '../../styles/iconButton.css';

/**
 * Компонент кнопки с иконкой. <br />
 * Компонет умеет отображать иконки. Размер кнопки явно не задается, т.к. зависит от размеров иконки.
 */
var IconButtonComponent = /*#__PURE__*/React.forwardRef(function IconButton(props, ref) {
  var icon = props.icon,
    rest = _objectWithoutProperties(props, _excluded);
  var preparedIcon = /*#__PURE__*/React.cloneElement(icon, {
    color: 'currentColor'
  });
  return /*#__PURE__*/React.createElement("button", _extends({}, rest, {
    className: styles['button'],
    ref: ref
  }), preparedIcon);
});
export var IconButton = /*#__PURE__*/React.memo(IconButtonComponent);